import ReactPlayer from 'react-player';

import { Panopto } from './custom-players/panopto';
import { ExternalVideo } from '/imports/ui/Types/meeting';

const YOUTUBE_SHORTS_REGEX = new RegExp(/^(?:https?:\/\/)?(?:www\.)?(youtube\.com\/shorts)\/.+$/);

const isUrlValid = (url: string) => {
  if (YOUTUBE_SHORTS_REGEX.test(url)) {
    const shortsUrl = url.replace('shorts/', 'watch?v=');

    return /^https.*$/.test(shortsUrl) && (ReactPlayer.canPlay(shortsUrl) || Panopto.canPlay(shortsUrl));
  }

  return /^https.*$/.test(url) && (ReactPlayer.canPlay(url) || Panopto.canPlay(url));
};

// Convert state (Number) to playing (Boolean)
const getPlayingState = (state: number) => {
  if (state === 1) return true;

  return false;
};

const calculateCurrentTime = (timeSync: number, externalVideoProps?: ExternalVideo) => {
  if (!externalVideoProps) return 0;
  
  const playerCurrentTime = externalVideoProps?.playerCurrentTime ?? 0;
  const playerPlaybackRate = externalVideoProps?.playerPlaybackRate ?? 1;
  const playerUpdatedAt = externalVideoProps?.updatedAt ?? Date.now();
  
  try {
    const playerUpdatedAtDate = new Date(playerUpdatedAt);
    const currentDate = new Date(Date.now() + (timeSync ?? 0));
    const isPaused = !externalVideoProps?.playerPlaying;
    
    if (isPaused) {
      return playerCurrentTime;
    }
    
    // Calculate time difference in seconds
    const timeDiffMs = currentDate.getTime() - playerUpdatedAtDate.getTime();
    const timeDiffSeconds = timeDiffMs / 1000;
    
    // Calculate expected current time based on playback rate and elapsed time
    const expectedTime = playerCurrentTime + (timeDiffSeconds * playerPlaybackRate);
    
    // Ensure we don't return negative time
    return Math.max(0, expectedTime);
  } catch (error) {
    console.warn('Error calculating current time:', error);
    return playerCurrentTime;
  }
};

export {
  isUrlValid,
  getPlayingState,
  calculateCurrentTime,
};
